import { render } from "./ShipmentImportDialog.vue?vue&type=template&id=251b86b4&scoped=true"
import script from "./ShipmentImportDialog.vue?vue&type=script&lang=js"
export * from "./ShipmentImportDialog.vue?vue&type=script&lang=js"

import "./ShipmentImportDialog.vue?vue&type=style&index=0&id=251b86b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251b86b4"]])

export default __exports__